/* storybook-check-ignore */
import { PropsWithChildren, useEffect, useRef } from 'react';
import { IntersectionOptions } from 'react-intersection-observer';

import { Box, BoxProps } from '@opendoor/bricks/core';

import { useInViewAfterLoad } from '../hooks/useInView';

type OnInViewChange = (inView: boolean) => void;

const InViewTrackerBox: React.FC<
  PropsWithChildren<{ onViewChange: OnInViewChange; boxProps?: BoxProps } & IntersectionOptions>
> = ({ onViewChange, children, boxProps, ...intersectionOptions }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { inView, entry } = useInViewAfterLoad({ ...intersectionOptions, ref });
  const inViewValueRef = useRef<boolean>(inView);
  useEffect(() => {
    if (!entry || inView == inViewValueRef.current) {
      return;
    }
    inViewValueRef.current = inView;
    onViewChange(inView);
  }, [inViewValueRef, inView]);
  return (
    <Box ref={ref} {...boxProps}>
      {children}
    </Box>
  );
};

export default InViewTrackerBox;
